export default {
  EXCEPTIONS: {
    STOLEN: { key: 'STOLEN', value: 'Extravio' },
    LOST: { key: 'LOST', value: 'Furto ou Roubo' },
    USER_ERROR: { key: 'USER_ERROR', value: 'Danificado pelo Cliente' },
    SYSTEM_ERROR: { key: 'SYSTEM_ERROR', value: 'Danificado pela Operação' },
  },
  STATUS: {
    DISABLED: 0,
    ENABLED: 1,
  },
  AVAILABILITY: {
    BDOS: { key: 'BDOS', value: 'Operador' },
    SELLING: { key: 'SELLING', value: 'Rede de Vendas' },
    ALL: { key: 'ALL', value: 'Todos' },
  },
  TYPE: {
    CARD: 'CARD',
  },
  FARE_TYPE: [
    { key: 'PERCENTAGE', value: 'Porcentagem %' },
    { key: 'FIXED_VALUE', value: 'Valor Fixo' },
  ],
  FARE_OPERATION: [
    { key: 'ADD', value: 'Acréscimo' },
    { key: 'REMOVE', value: 'Decréscimo' },
  ],
  SELLING_TIMING_TYPE: [
    { key: 'MINUTE', value: 'Minutos' },
    { key: 'HOUR', value: 'Horas' },
    { key: 'DAY', value: 'Dia' },
    { key: 'WEEK', value: 'Semanas' },
    { key: 'MONTH', value: 'Mês' },
  ],
  NEW_SELLING_TIMING_TYPE: [
    { key: 'MINUTE', value: 'Minutos' },
    { key: 'HOUR', value: 'Horas' },
    { key: 'DAY', value: 'Dia' },
  ],
  AVAILABILITY_SELLING: {
    OWN: 'OWN',
    EXTERNAL: 'EXTERNAL',
  },
  TICKET_SALES_RULES_TYPE: [
    { key: 'PERCENTAGE', value: '%' },
    { key: 'FIXED_VALUE', value: 'passagens' },
  ],
  BOOKED_TICKET: 'BOOKED_TICKET',
};
